//angular
import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillingPeriodsValues, BillCycleTypeValues, ChargeCutOffRulesType, ChargeType, collectionOfChargeCutOffRuleType, collectionOfMonthDay, SubscriptionRuleTypes, VisibleState } from 'src/app/app.data';
import { DataSharingService, UtilsService } from 'src/app/_core/services';
//app animations
import { AppAnimations } from 'src/app/_shared/animations';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
//app shared
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { ValidatorService } from 'src/app/_shared/validators/validator.service';
@Component({
  animations: [AppAnimations],
  selector: 'app-charge-cutoff-rules',
  templateUrl: './charge-cutoff-rules.component.html'
})
export class FormChargeCutOffRulesComponent implements OnInit, OnDestroy {
  checkedCutOffRulesEnabled: boolean = false;
  cleaveNumIntegerOptions: any;
  collectionOfMonthDay: Array<any> = collectionOfMonthDay;
  collectionOfChargeCutOffRuleType: Array<DropDown> = collectionOfChargeCutOffRuleType;
  form: FormGroup;
  model: any;
  selectedCutOffRuleType: ChargeCutOffRulesType = ChargeCutOffRulesType.date;

  private subs = new Unsubscriber();

  @Input() _chargeType = ChargeType;
  @Input() _chargeCutOffRuleType = ChargeCutOffRulesType;
  @Input() _billCycleTypeValues = BillCycleTypeValues;
  @Input() _data: any;
  @Input() _selectedChargeType: ChargeType = ChargeType.oneTimeCharge;
  @Input() _selectedBillCycleTypeValues: BillCycleTypeValues = BillCycleTypeValues.subscriptionStartDay;
  @Input() _visibleState = VisibleState;

  @Output() _emitCutOffErrors: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitCutOffRules: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private _shareData: DataSharingService,
    private _validatorService: ValidatorService,
    private utils: UtilsService
  ) {
    this.subs.addSub = this._shareData.getSettingsVariables().subscribe(([_decimalPlaces, decimalToken, thousandsToken]) => {
      this.cleaveNumIntegerOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        stripLeadingZeroes: false,
        numeralDecimalScale: 0,
        delimiter: thousandsToken,
        numeralDecimalMark: decimalToken
      };
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.model = this._data?.ratePlanCharge?.rules?.find(x => x.ruleType == SubscriptionRuleTypes.cutoff);
    this.setUpForm();
  }

  onChangeCutOffRuleType(_value) {
    this.selectedCutOffRuleType = _value;
  }

  setUpForm() {
    let cutOffDay: number = 1;
    let cutOffMonth: number = 1;
    let cutOffWeekday: string = 'sunday';

    const cutOffTypeSelected = this._data?.ratePlanCharge?.cutOffType === ChargeCutOffRulesType.day ? ChargeCutOffRulesType.day : ChargeCutOffRulesType.date;
    
    this.selectedCutOffRuleType = cutOffTypeSelected;

    switch (this.data?.ratePlanCharge?.cutOffType) {
      case BillingPeriodsValues.days:
        cutOffDay = this._data?.ratePlanCharge?.cutOffValue;
        break;
      case BillingPeriodsValues.weeks:
        cutOffWeekday = this._data?.ratePlanCharge?.cutOffValue;
        break;
      case BillingPeriodsValues.months:
        cutOffDay = this.utils.convertToNumber(this._data?.ratePlanCharge?.cutOffValue);
        cutOffMonth = this.utils.convertToNumber(this._data?.ratePlanCharge?.cutOffValue);
        break;
    }
    
    this.model = this._data?.ratePlanCharge.cutOffType;
    this.checkedCutOffRulesEnabled = this.model ? true : false;
    this.form = this._fb.group({
      cutOffDay: [cutOffDay, [Validators.min(1)]],
      cutOffMonth: [cutOffMonth, [Validators.min(1)]],
      cutOffRuleType: cutOffTypeSelected,
      cutOffRulesEnabled: [this.checkedCutOffRulesEnabled],
      weeklyCutOffCycleDay: cutOffWeekday
    });
  }

  setBodyParams() {
    if(this.form.get('cutOffRulesEnabled').value) {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.form.markAsDirty();
        this._emitCutOffErrors.emit(true);
        return;
      }

      let cutOffType = '';
      let cutOffValue = '';

      if(this.selectedCutOffRuleType === 'day') {
        cutOffType = BillingPeriodsValues.days;
        cutOffValue = this.form.get('cutOffDay').value;
      } else {
        cutOffType = this._selectedBillCycleTypeValues === this._billCycleTypeValues.specificDayOfWeek ? BillingPeriodsValues.weeks : BillingPeriodsValues.months;
        cutOffValue = this._selectedBillCycleTypeValues === this._billCycleTypeValues.specificDayOfWeek ? this.form.get('weeklyCutOffCycleDay').value : this.form.get('cutOffMonth').value;
      }

      let bodyParams: any = {
        cutOffType: cutOffType,
        cutOffValue: String(cutOffValue)
      };

      this._emitCutOffRules.emit(bodyParams);
    } else {

      let bodyParams: any = {
        cutOffType: null,
        cutOffValue: null
      };
      this._emitCutOffRules.emit(bodyParams);
    }
  }

}
